import { faPause, faCirclePlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "./Spinner";

function PlayButton({ playSongHandler, isPlaying, isLoading }) {
  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <FontAwesomeIcon
          onClick={playSongHandler}
          className="h-6 w-6 radio__icon hover:text-[#FF1A1A] mr-1 md:mr-2 cursor-pointer"
          icon={isPlaying ? faPause : faCirclePlay}
        />
      )}
    </>
  );
}

export default PlayButton;
